import React from "react";
import BuildingForm from "./BuildingForm";

export default function AddBuilding(){

    return(
        <BuildingForm type="Add" />
    )
}
